import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Layout/Header/Header";
import Footer from "../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../components/Common/ScrollTop";
import OffWrap from "../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../components/Common/Breadcumb";
import SearchModal from "../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../assets/img/logo/jntua-logo.png";
import { fetchData, imageBaseURL } from "../../../../utils/fetchData";
import Accreditation from "../../../../components/Common/Accreditation";
import { useFontSize } from "../../../../FontSizeContext";
import { getAPIPath, getMenu } from "../../../../utils/getDomainData";

const OTPRI_GrievanceRedressalCell = () => {
    const [data, setData] = useState([]);
    let location = useLocation();
    const currentDomain = location.pathname.split("/")[1];
    const { fontSize } = useFontSize();

    useEffect(() => {
        fetchData(getAPIPath(currentDomain)?.GRC, setData);
    }, [currentDomain]);

    const grievanceData = data?.data?.attributes;

    return (
        <React.Fragment>
            <Helmet>
                <title>Grievance Redressal Cell | Oil Technological & Pharmaceutical Research Institute | JNTU Anantapur</title>
                <meta
                    name="description"
                    content="Grievance Redressal Cell at JNTUA Oil Technological and Pharmaceutical Research Institute (OT&PRI) - Access anti-ragging guidelines, complaint procedures, and grievance redressal mechanisms."
                />
                <meta
                    name="keywords"
                    content="OTPRI Grievance Redressal Cell, Anti-Ragging, Complaint Committee, JNTUA, Student Grievances, Internal Complaint Committee"
                ></meta>
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="home"
                TopBar="enable"
                TopBarClass="topbar-area dark-primary-bg hidden-lg"
            />
            <style>
                {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .library-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }
                    
                    .grievance-section {
                        background: #fff;
                        padding: 50px 0;
                    }
                    .section-heading {
                        color: #007bff;
                        font-weight: bold;
                        margin-bottom: 40px;
                        border-bottom: 3px solid #007bff;
                        padding-bottom: 10px;
                        display: inline-block;
                        text-align: center;
                        width: 100%;
                    }
                    .links-container {
                        padding: 20px 0;
                    }
                    .link-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
                        gap: 25px;
                        margin-top: 30px;
                    }
                    .link-item {
                        position: relative;
                        overflow: hidden;
                        border-radius: 12px;
                        box-shadow: 0 8px 25px rgba(0,0,0,0.1);
                        transition: all 0.3s ease;
                        background: #fff;
                        border: 1px solid #e9ecef;
                    }
                    .link-item:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 15px 35px rgba(0,0,0,0.15);
                    }
                    .link-card {
                        position: relative;
                        padding: 25px;
                        text-decoration: none;
                        color: inherit;
                        display: block;
                        height: 100%;
                    }
                    .link-card:hover {
                        text-decoration: none;
                        color: inherit;
                    }
                    .link-icon {
                        width: 50px;
                        height: 50px;
                        background: linear-gradient(135deg, #007bff, #0056b3);
                        border-radius: 12px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-bottom: 20px;
                        transition: transform 0.3s ease;
                    }
                    .link-item:hover .link-icon {
                        transform: scale(1.1);
                    }
                    .link-icon i {
                        font-size: 24px;
                        color: white;
                    }
                    .link-title {
                        font-weight: bold;
                        color: #333;
                        margin-bottom: 10px;
                        font-size: 1.1rem;
                        line-height: 1.4;
                    }
                    .link-description {
                        color: #666;
                        font-size: 0.9rem;
                        line-height: 1.5;
                        margin-bottom: 15px;
                    }
                    .link-meta {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-top: auto;
                        padding-top: 15px;
                        border-top: 1px solid #f1f3f4;
                    }
                    .file-type {
                        color: #1976d2;
                        font-size: 0.9rem;
                        display: flex;
                        align-items: center;
                    }
                    .file-size {
                        background: #e3f2fd;
                        color: #1976d2;
                        padding: 4px 8px;
                        border-radius: 20px;
                        font-size: 0.75rem;
                        font-weight: 600;
                    }
                    .no-links {
                        text-align: center;
                        color: #666;
                        font-style: italic;
                        padding: 80px 20px;
                        background: #f8f9fa;
                        border-radius: 15px;
                        margin: 40px 0;
                    }
                    .no-links h3 {
                        color: #333;
                        margin-bottom: 15px;
                    }
                    .intro-section {
                        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
                        padding: 40px;
                        border-radius: 15px;
                        margin-bottom: 40px;
                        text-align: center;
                        border: 1px solid #dee2e6;
                    }
                    .intro-title {
                        color: #007bff;
                        font-size: 1.8rem;
                        font-weight: bold;
                        margin-bottom: 20px;
                    }
                    .intro-description {
                        color: #495057;
                        font-size: 1.1rem;
                        line-height: 1.6;
                        max-width: 700px;
                        margin: 0 auto;
                    }
                    .stats-bar {
                        background: #007bff;
                        color: white;
                        padding: 15px 30px;
                        border-radius: 50px;
                        display: inline-block;
                        margin-top: 20px;
                        font-weight: 500;
                    }
                    .category-section {
                        margin-bottom: 40px;
                    }
                    .category-title {
                        color: #28a745;
                        font-size: 1.3rem;
                        font-weight: bold;
                        margin-bottom: 20px;
                        padding: 12px 20px;
                        background: linear-gradient(135deg, #e8f5e8, #d4edda);
                        border-left: 4px solid #28a745;
                        border-radius: 8px;
                    }
                `}
            </style>

            <div className="pageTopOffset">
                {/* breadcrumb-area-start */}
                <SiteBreadcrumb
                    pageTitle="Grievance Redressal Cell"
                    pageName="Grievance Redressal Cell"
                    breadcrumbsClass="breadcrumb-bg"
                />
                {/* breadcrumb-area-start */}
                {getMenu(currentDomain)}
                
                <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
                    <div className="container">
                        <div className="row">
                            <div className="col pl-20 md-pl-14">
                                <div className="row">
                                    <div className="rs-inner-blog col-lg-12">

                                        {/* Introduction Section */}
                                        <div className="intro-section">
                                            <h2 className="intro-title">Grievance Redressal Cell</h2>
                                            <p className="intro-description">
                                                The Grievance Redressal Cell ensures a safe and conducive learning environment 
                                                for all students. Access important guidelines, policies, and procedures related to 
                                                anti-ragging measures, complaint mechanisms, and grievance redressal processes.
                                            </p>
                                            {grievanceData?.links && (
                                                <div className="stats-bar">
                                                    {grievanceData.links.length} Important Documents Available
                                                </div>
                                            )}
                                        </div>

                                        {/* Grievance Links */}
                                        {grievanceData?.links && grievanceData.links.length > 0 ? (
                                            <div className="grievance-section">
                                                <h2 className="section-heading">Important Documents & Guidelines</h2>
                                                
                                                <div className="links-container">
                                                    <div className="link-grid">
                                                        {grievanceData.links.map((link, index) => {
                                                            const isCommittee = link.label.toLowerCase().includes('committee');
                                                            const isAntiRagging = link.label.toLowerCase().includes('ragging') || 
                                                                                link.label.toLowerCase().includes('anti');
                                                            
                                                            let iconClass = 'fas fa-file-pdf';
                                                            if (isCommittee) {
                                                                iconClass = 'fas fa-users';
                                                            } else if (isAntiRagging) {
                                                                iconClass = 'fas fa-shield-alt';
                                                            }

                                                            return (
                                                                <div key={link.id || index} className="link-item">
                                                                    <a 
                                                                        href={`${imageBaseURL}${link.content?.data?.attributes?.url}`}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                        className="link-card"
                                                                    >
                                                                        <div className="link-title">
                                                                            {link.label}
                                                                        </div>
                                                                        <div className="link-description">
                                                                            {isCommittee ? 
                                                                                "Information about committee structure, members, and procedures." :
                                                                                isAntiRagging ?
                                                                                "Guidelines and regulations for preventing ragging in educational institutions." :
                                                                                "Important document for grievance redressal processes."
                                                                            }
                                                                        </div>
                                                                        <div className="link-meta">
                                                                            <span className="file-type">
                                                                                <i className={iconClass} style={{marginRight: '8px'}}></i>
                                                                            </span>
                                                                            <span className="file-size">
                                                                                PDF
                                                                            </span>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>

                                                {/* Categorized Sections */}
                                                <div className="category-section">
                                                    <div className="category-title">
                                                        <i className="fas fa-info-circle me-2"></i>
                                                        Important Information
                                                    </div>
                                                    <p style={{color: '#666', lineHeight: '1.6', padding: '0 20px'}}>
                                                        • All documents are available in PDF format for easy download and reference<br/>
                                                        • Committee information includes contact details and reporting procedures<br/>
                                                        • Anti-ragging guidelines are mandatory reading for all students<br/>
                                                        • For immediate assistance, contact the grievance committee directly
                                                    </p>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="no-links">
                                                <h3>Grievance Redressal Cell</h3>
                                                <p>Important documents and guidelines will be updated soon. Please check back later for grievance redressal procedures and anti-ragging policies.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Accreditation />

            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />

            {/* scrolltop-start */}
            <ScrollToTop scrollClassName="scrollup orange-color" />
            {/* scrolltop-end */}

            <SearchModal />
        </React.Fragment>
    );
};

export default OTPRI_GrievanceRedressalCell;